import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DownloadSvgComponent from "@assets/svg-components/download";

function BulkDownloadDropdown(props: any) {
  const { dropdownOptions, downloadLoading } = props;
  
  return (
    <div className="filterbar-icon-button-holder">
      <UncontrolledDropdown className="common-dropdown">
        <DropdownToggle className="px-0 text-center">
          <div className="add-filter-wrapper__filter-container ms-0">
            <div className="cursor-pointer">
              <DownloadSvgComponent color='#5f6368' size={24} />
              <p className="small_text__12">{"DOWNLOAD"}</p>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          {getValue(dropdownOptions, `length`, 0) > 0 &&
            dropdownOptions.map((item: object, index: number) => {
              return (
                <DropdownItem
                  key={index}
                  onClick={
                    downloadLoading
                      ? null
                      : getValue(item, `onClick`, null)
                  }
                >
                  {getValue(item, `label`, "")}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
}

export default BulkDownloadDropdown; 